<template>
  <div class="section-container">
    <!-- Header with Add Button -->
    <b-row align-v="center" class="mb-2">
      <b-col md="12">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-uppercase font-weight-bold mb-0" style="display: flex; align-items: center">
            <i class="fas fa-file-alt mr-2" style="font-size: 20px !important;"></i> Publications
          </h5>
          <b-button size="sm" variant="info" @click="showAddModal">
            <i class="fas fa-plus mr-1" style="font-size: 12px !important;"></i> Add
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-row v-if="publications && publications.length > 0" align-v="center" class="mb-3">
      <b-col md="12">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No.</th>
              <th>Description</th>
              <th>Category</th>
              <th>Academic Year</th>
              <th>Period</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="publication in sortedPublications" :key="publication.id">
              <td>{{ publication.si_no }}</td>
              <td>{{ publication.description }}</td>
              <td>{{ publication.category }}</td>
              <td>{{ publication.academic_year }}</td>
              <td>{{ publication.period }}</td>
              <td>
                <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;"
                  @click="editPublication(publication)"></i>
                <i class="fas fa-trash fa-sm ml-2" style="cursor: pointer; color: #dc3545;"
                  @click="deletePublication(publication)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <!-- Modal -->
    <b-modal v-model="showModal" title="Publication" @hide="resetForm" hide-footer>
      <b-form @submit.prevent="createOrUpdatePublication">
        <b-form-group label="Sl No">
          <b-form-input type="number" v-model="publication.si_no"></b-form-input>
        </b-form-group>
        <b-form-group label="Description">
          <b-form-input v-model="publication.description"></b-form-input>
        </b-form-group>
        <b-form-group label="Category">
          <b-form-input v-model="publication.category"></b-form-input>
        </b-form-group>
        <b-form-group label="Academic Year">
          <b-form-input v-model="publication.academic_year"></b-form-input>
        </b-form-group>
        <b-form-group label="Period">
          <b-form-input v-model="publication.period"></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Save</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["profile", "profileId"],
  data() {
    return {
      showModal: false,
      editIndex: null,
      publications: this.profile.publications || [],
      publication: { si_no: "", description: "", category: "", academic_year: "", period: "" },
    };
  },
  computed: {
    sortedPublications() {
      return [...this.publications].sort((a, b) => Number(a.si_no) - Number(b.si_no));
    }
  },
  methods: {
    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile.publications = response.data.publications;
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
    async createOrUpdatePublication() {
      try {
        const url = this.$store.getters.getAPIKey.mainAPI + `/userprofiles/publications`;
        let response;

        if (this.editIndex === null) {
          // Create
          response = await this.$axios.post(url, {
            ...this.publication,
            si_no: Number(this.publication.si_no),
            user_profile_id: this.profile.id,
          });
          this.publications.unshift(response.data);
        } else {
          // Update
          const updateUrl = `${url}/${this.publication.id}`;
          response = await this.$axios.put(updateUrl, {
            ...this.publication,
            si_no: Number(this.publication.si_no),
          });
          this.publications.splice(this.editIndex, 1, response.data);
        }

        this.$toast.success("Profile Updated", { position: "top", duration: 3000 });
        this.getProfile();
        this.showModal = false;
      } catch (error) {
        console.error("Error updating publication:", error);
        this.$toast.error("Failed to update profile", { position: "top", duration: 3000 });
      }
    },
    showAddModal() {
      this.resetForm();
      this.showModal = true;
    },
    editPublication(publication) {
      this.publication = { ...publication };
      this.editIndex = this.publications.findIndex(p => p.id === publication.id);
      this.showModal = true;
    },
    async deletePublication(publication) {
      try {
        const deleteUrl = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/publications/${publication.id}`;
        await this.$axios.delete(deleteUrl);

        const index = this.publications.findIndex(p => p.id === publication.id);
        if (index !== -1) {
          this.publications.splice(index, 1);
        }
        this.getProfile();
        this.$toast.success("Publication deleted", { position: "top", duration: 3000 });
      } catch (error) {
        console.error("Error deleting publication:", error);
        this.$toast.error("Failed to delete publication", { position: "top", duration: 3000 });
      }
    },
    resetForm() {
      this.publication = { si_no: "", description: "", category: "", academic_year: "", period: "" };
      this.editIndex = null;
    }
  }
};
</script>

<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
</style>
